export default __webpack_public_path__ + "static/events-light-10f617dcf8cfa799f3156685cb27da76.png";